/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PersonalDataExposureCategory } from './PersonalDataExposureCategory';
import {
  PersonalDataExposureCategoryFromJSON,
  PersonalDataExposureCategoryFromJSONTyped,
  PersonalDataExposureCategoryToJSON,
} from './PersonalDataExposureCategory';

/**
 *
 * @export
 * @interface PaginatedPersonalDataExposureCategoryList
 */
export interface PaginatedPersonalDataExposureCategoryList {
  /**
   *
   * @type {number}
   * @memberof PaginatedPersonalDataExposureCategoryList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedPersonalDataExposureCategoryList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedPersonalDataExposureCategoryList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<PersonalDataExposureCategory>}
   * @memberof PaginatedPersonalDataExposureCategoryList
   */
  results: Array<PersonalDataExposureCategory>;
}

/**
 * Check if a given object implements the PaginatedPersonalDataExposureCategoryList interface.
 */
export function instanceOfPaginatedPersonalDataExposureCategoryList(
  value: object,
): value is PaginatedPersonalDataExposureCategoryList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedPersonalDataExposureCategoryListFromJSON(
  json: any,
): PaginatedPersonalDataExposureCategoryList {
  return PaginatedPersonalDataExposureCategoryListFromJSONTyped(json, false);
}

export function PaginatedPersonalDataExposureCategoryListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedPersonalDataExposureCategoryList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(PersonalDataExposureCategoryFromJSON),
  };
}

export function PaginatedPersonalDataExposureCategoryListToJSON(
  value?: PaginatedPersonalDataExposureCategoryList | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(PersonalDataExposureCategoryToJSON),
  };
}
